import { useState } from 'react';
import { Mail, Bell, Check } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { Input } from '../components/ui/input';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const SubscribeForm = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter your email');
      return;
    }
    
    setLoading(true);
    try {
      await axios.post(`${API_URL}/subscribe`, {
        email,
        name,
        new_releases: true,
        merch_drops: true
      });
      setSubscribed(true);
      toast.success('Subscribed! You\'ll get notified about new releases.');
    } catch (error) {
      toast.error('Failed to subscribe. Try again.');
    } finally {
      setLoading(false);
    }
  };

  if (subscribed) {
    return (
      <div className="glass-card p-6 text-center">
        <div className="w-12 h-12 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-4">
          <Check className="w-6 h-6 text-green-400" />
        </div>
        <h3 className="text-xl font-bold mb-2">You're In! 🎉</h3>
        <p className="text-gray-400">We'll notify you when new music drops.</p>
      </div>
    );
  }

  return (
    <div className="glass-card p-6" data-testid="subscribe-form">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
          <Bell className="w-5 h-5 text-white" />
        </div>
        <div>
          <h3 className="font-bold">Get Notified</h3>
          <p className="text-sm text-gray-400">New releases & exclusive drops</p>
        </div>
      </div>
      
      <form onSubmit={handleSubmit} className="space-y-3">
        <Input
          type="text"
          placeholder="Your name (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="input-dark"
          data-testid="subscribe-name"
        />
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input-dark"
          required
          data-testid="subscribe-email"
        />
        <button 
          type="submit" 
          disabled={loading}
          className="w-full btn-primary flex items-center justify-center gap-2"
          data-testid="subscribe-submit"
        >
          <Mail className="w-4 h-4" />
          {loading ? 'Subscribing...' : 'Subscribe'}
        </button>
      </form>
      
      <p className="text-xs text-gray-500 mt-3 text-center">
        No spam. Unsubscribe anytime.
      </p>
    </div>
  );
};
